import { Component } from '@angular/core';

@Component({
  selector: 'app-oil-gas',
  standalone: false,
  templateUrl: './oil-gas.component.html',
  styleUrl: './oil-gas.component.scss'
})
export class OilGasComponent {
  oilAppUrl: string = 'https://surface-prod.crm.dynamics.com/main.aspx?appid=f1ee46d4-92d0-ef11-8eea-00224803d0c5&pagetype=entitylist&etn=cr56c_oilandgastakeaways&viewid=df8f1310-d813-4bb8-8770-811450ea78e4&viewType=1039&lid=1742224176352';
}
